<div>
    {{ params.displayName }}
</div>
<tapestry-icon [size]="params.iconSize" [name]="params.name"></tapestry-icon>
